function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { genComponentStyleHook } from "../../_util/genComponentStyleHook";
var genSizeStyle = function genSizeStyle(spinDotSize, token) {
  var componentCls = token.componentCls,
    colorText = token.colorText;
  var spinDotWidth = spinDotSize;
  var spinDotHight = spinDotWidth * (295 / 397);
  return _defineProperty({}, "&".concat(componentCls, "-oceanbase"), _defineProperty(_defineProperty({}, "".concat(componentCls, "-dot"), {
    width: spinDotWidth,
    height: spinDotHight
  }), "".concat(componentCls, "-text"), {
    width: spinDotWidth,
    color: colorText
  }));
};
var genNestedSizeStyle = function genNestedSizeStyle(spinDotSize, token) {
  var componentCls = token.componentCls,
    fontSize = token.fontSize;
  var spinDotWidth = spinDotSize;
  // oceanbase indicator is rectangle instead of square, should calculate actual height by ratio
  // width: 295px
  // height: 397px
  var spinDotHight = spinDotWidth * (295 / 397);
  var dotMarginLeft = -spinDotWidth / 2;
  var dotMarginTop = -spinDotHight / 2;
  var textPaddingTop = (spinDotHight - fontSize) / 2 + 2;
  return _defineProperty({}, "&".concat(componentCls, "-oceanbase, & > ").concat(componentCls, "-oceanbase"), _defineProperty(_defineProperty(_defineProperty({}, "".concat(componentCls, "-dot"), {
    marginLeft: dotMarginLeft,
    marginTop: dotMarginTop
  }), "".concat(componentCls, "-text"), {
    paddingTop: textPaddingTop
  }), "&".concat(componentCls, "-show-text ").concat(componentCls, "-dot"), {
    marginTop: dotMarginTop - 10
  }));
};
export var genSpinStyle = function genSpinStyle(token) {
  var componentCls = token.componentCls,
    spinDotSize = token.spinDotSize,
    spinDotSizeSM = token.spinDotSizeSM,
    spinDotSizeLG = token.spinDotSizeLG;
  return _defineProperty(_defineProperty({}, "".concat(componentCls), _defineProperty(_defineProperty(_defineProperty({}, "&", genSizeStyle(spinDotSize, token)), "&-sm", genSizeStyle(spinDotSizeSM, token)), "&-lg", genSizeStyle(spinDotSizeLG, token))), "".concat(componentCls, "-nested-loading"), _defineProperty({}, "> div > ".concat(componentCls), _defineProperty(_defineProperty(_defineProperty({}, "&", genNestedSizeStyle(spinDotSize, token)), "&-sm", genNestedSizeStyle(spinDotSizeSM, token)), "&-lg", genNestedSizeStyle(spinDotSizeLG, token))));
};
export default (function (prefixCls) {
  var useStyle = genComponentStyleHook('Spin', function (token) {
    // should expand by 2x for oceanbase indicator
    // because it's inner padding is smaller than antd default indicator
    // const ratio = 3;
    return [genSpinStyle(_objectSpread(_objectSpread({}, token), {}, {
      // https://github.com/ant-design/ant-design/blob/master/components/spin/style/index.tsx#L238
      // spinDotSize: (token.controlHeightLG / 2) * ratio,
      // spinDotSizeSM: token.controlHeightLG * 0.35 * ratio,
      // spinDotSizeLG: token.controlHeight * ratio,
      spinDotSize: token.controlHeight * 1.75,
      // 56,
      spinDotSizeSM: token.controlHeight * 1.125,
      // 36
      spinDotSizeLG: token.controlHeight * 2.25 // 72
    }))];
  });
  return useStyle(prefixCls);
});